<template>
  <pt-counselor-manage class="pt-counselor-manage__withData" :companys="companys" :positions="positions" @exportAllCode="exportAllCode"
  @exportCounselors="exportCounselors" :exportLoading="exportLoading" :exportCounselorsLoading="exportCounselorsLoading"></pt-counselor-manage>
</template>

<script>
import PtCounselorManage from './index'
export default {
  name: 'pt-counselor-manage__withData',
  components: {
    'pt-counselor-manage': PtCounselorManage
  },
  methods: {
    exportAllCode (data) {
      this.exportLoading = true
      this.$store.dispatch('getCounselorCodeZip', data).then(res => {
        this.exportLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出缴费码失败')
      })
    },
    exportCounselors (data) {
      this.exportCounselorsLoading = true
      this.$store.dispatch('exportCounselors', data).then(res => {
        this.exportCounselorsLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportCounselorsLoading = false
        this.$message.error(err || '导出咨询师失败')
      })
    },
    getCompanys () {
      let data = {
        pageableParam: {
          page: 0,
          size: 9999
        },
        type: 'BRANCH'
      }
      this.$store.dispatch('getBranchCompanyList', data).then(data => {
        this.companys = data.data.map(e => {
          return {
            label: e.fullName,
            value: e.id
          }
        })
      }).catch(err => {
        this.$message.error(err)
      })
    },
    getPositions () {
      this.$store.dispatch('getPosition').then(data => {
        this.positions = data.map(e => {
          return {
            label: e.name,
            value: e.id
          }
        })
      }).catch(err => {
        this.$message.error(err)
      })
    }
  },
  data () {
    return {
      companys: [],
      positions: [],
      exportLoading: false,
      exportCounselorsLoading: false
    }
  },
  computed: {
    // companys () {
    //   return this.$store.state.detectionPackageList
    // }
  },
  created () {
    this.getCompanys()
    this.getPositions()
  }
}
</script>
